import axios from '@/utils/request'

export default {
	// 2020-12-19
	search(params) {
		return axios.get('/synchronize-editions', params)
	},
	// 2020-12-19
	count() {
		return axios.get('/synchronize-editions/count')
	},
	// 2020-12-19
	synchronize(id, params) {
		return axios.put('/synchronize-editions/' + id + '/synchronize', params)
	},
	// 2020-12-19
	findById(id) {
		return axios.get('/synchronize-editions/' + id)
	}
}

